import { track } from "../track";

export const trackCreatePhotoUploadScs = (params: { photo_count: number }) =>
  track({ event: "create_photo_upload_scs", ...params });
